// extracted by mini-css-extract-plugin
export var body = "iUGOHhUzxhFk_DVCxMv6";
export var fontBold = "VMcoZykdXUbux6A7XC8A";
export var fontMedium = "PFHtXkDxVX8HPKS3b4aZ";
export var fontRegular = "apHbDEMtambyavTnrdj2";
export var large = "kBpL3bho2xHaxXQC4XpV";
export var micro = "M7Cs1YBHB7hghR4VfMpQ";
export var mini = "DgTWOAwAF_3Abowz3w12";
export var root = "RBF9TeJzls4Ia8XZPmEK";
export var small = "yzYY3NS7SRZudbzKAxh0";